/** The states the badge can show — the API's reachability, not a job's. */
export type Status = "ok" | "degraded" | "waiting" | "late" | "unreachable" | "checking";

const STYLES: Record<Status, string> = {
  ok: "bg-emerald-500/12 text-emerald-700 dark:text-emerald-300 ring-emerald-500/25",
  waiting: "bg-sky-500/12 text-sky-700 dark:text-sky-300 ring-sky-500/25",
  checking: "bg-sky-500/12 text-sky-700 dark:text-sky-300 ring-sky-500/25",
  degraded: "bg-amber-500/12 text-amber-700 dark:text-amber-300 ring-amber-500/25",
  late: "bg-amber-500/12 text-amber-700 dark:text-amber-300 ring-amber-500/25",
  unreachable: "bg-rose-500/12 text-rose-700 dark:text-rose-300 ring-rose-500/25",
};

export function StatusBadge({ status, label }: { status: Status; label?: string }) {
  const live = status === "checking" || status === "waiting";

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs
        font-medium ring-1 ring-inset ${STYLES[status]}`}
    >
      {/* A pulse marks the states that are still expected to change. */}
      <span
        aria-hidden="true"
        className={`size-1.5 rounded-full bg-current ${live ? "animate-pulse" : ""}`}
      />
      {label ?? status}
    </span>
  );
}
